export default {
  'simulation[store_id]': 2,
  'simulation[credere_seller_id]': 2,
  'simulation[vehicle][name]': 2,
  'simulation[vehicle][credere_vehicle_model_id]': 2,
  'simulation[vehicle][_vehicle_search_by_license_plate]': 2,

  'lead[name]': 2,
  'lead[retrieve_occupation]': 2,

  'lead[address][state]': 2,
  'lead[address][street]': 2,
};
